/* === INBUS — Discount Bar — V3.1 (Metaobject tiers, new class system, CART SNAP PROPERTIES RESTORED) === */
(function(){
  function onReady(fn){
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);
  }

  function nbspPct(s){ return String(s||'').replace('%','\u202F%'); }
  function toInt(v){ var n=parseInt(String(v==null?'':v).replace(/\D/g,''),10); return isNaN(n)?0:n; }
  function clampMin1(n){ return n<1?1:n; }
  function ceilToMultiple(n,m){ return Math.ceil(n/m)*m; }
  function floorToMultiple(n,m){ return Math.floor(n/m)*m; }

  function isVisible(el){
    if(!el) return false;
    if(el.offsetParent!==null) return true;
    var r=el.getBoundingClientRect();
    return !!(r.width||r.height);
  }

  function getProductForm(root){
    var section=root.closest('section')||root.parentElement;
    if(section){
      var f=section.querySelector('form[action*="/cart/add"]');
      if(f) return f;
    }
    return root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function getCurrentVariantId(form){
    if(!form) return null;
    var el=form.querySelector('input[name="id"], select[name="id"]');
    if(!el) return null;
    var v=parseInt(el.value,10);
    return isNaN(v)?null:v;
  }

  var Q_SEL=[
    'input[name="quantity"]:not([type="hidden"]):not([disabled])',
    '.quantity__input:not([disabled])',
    'input#Quantity:not([disabled])',
    'input[id^="Quantity-"]:not([disabled])'
  ];
  function findQtyInput(form){
    if(form){
      for(var i=0;i<Q_SEL.length;i++){
        var el=form.querySelector(Q_SEL[i]);
        if(el && isVisible(el)) return el;
      }
    }
    for(var j=0;j<Q_SEL.length;j++){
      var el2=document.querySelector(Q_SEL[j]);
      if(el2 && isVisible(el2)) return el2;
    }
    return null;
  }

  /* cart cache */
  var cartCache=null;
  function fetchCart(){
    return fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
      .then(function(j){ cartCache=j; return j; })
      .catch(function(){ cartCache=null; return null; });
  }
  function computeInCartQty(variantId){
    if(!variantId||!cartCache||!Array.isArray(cartCache.items)) return 0;
    var vid=toInt(variantId);
    return cartCache.items.reduce(function(s,it){
      return s + ((toInt(it && it.id)===vid) ? (toInt(it && it.quantity)||0) : 0);
    },0);
  }

  function readTiersFromDataset(root){
    var tiers=[];
    for(var i=1;i<=5;i++){
      var q=toInt(root.getAttribute('data-tier-'+i+'-qty'));
      var v=toInt(root.getAttribute('data-tier-'+i+'-value'));
      if(q>0 && v>0){
        tiers.push({qty:q,value:v,label:String(v)+'%'});
      }
    }
    tiers.sort(function(a,b){ return a.qty-b.qty; });
    return tiers;
  }

  /* === NEW: write snap config into line-item properties so Cart-JS can enforce snap === */
  function ensureLineItemProperties(form, snapActive, threshold, step){
    if(!form) return;

    function upsert(name, value){
      var sel = 'input[name="'+name.replace(/"/g,'\\"')+'"]';
      var el = form.querySelector(sel);
      if(!el){
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      el.value = String(value);
    }

    // Always set enabled (explicitly off if not active)
    upsert('properties[_inbus_snap_enabled]', snapActive ? '1' : '0');

    // Only set threshold/step when active (else empty)
    if(snapActive){
      upsert('properties[_inbus_snap_threshold]', String(threshold));
      upsert('properties[_inbus_snap_step]', String(step));
    } else {
      upsert('properties[_inbus_snap_threshold]', '');
      upsert('properties[_inbus_snap_step]', '');
    }
  }

  function initOne(root){
    if(!root || root._inbusInit) return;
    root._inbusInit = true;

    var tiers = readTiersFromDataset(root);
    var goal  = tiers.length ? tiers[tiers.length-1].qty : 1;

    var nameSingular = root.getAttribute('data-inbus-name-singular') || '';
    var namePlural   = root.getAttribute('data-inbus-name-plural') || '';

    var snapEnabled = (String(root.getAttribute('data-inbus-snap-enabled')) === '1'
                    || String(root.getAttribute('data-inbus-snap-enabled')) === 'true');

    var snapThreshold = toInt(root.getAttribute('data-inbus-snap-threshold'));
    var snapStep      = toInt(root.getAttribute('data-inbus-snap-step'));

    // RULE: if anything missing -> snap OFF silently
    var snapActive = !!(snapEnabled && snapThreshold > 0 && snapStep > 0);

    var bar  = root.querySelector('.inbus-comp-product-discobar__bar');
    var info = root.querySelector('.inbus-font-product-discobar-info');
    var hint = root.querySelector('.inbus-font-product-discobar-hint');
    if(!bar||!info||!hint) return;

    bar.innerHTML='';
    var boxes=[];
    for(var i=1;i<=goal;i++){
      var seg=document.createElement('div');
      seg.className='inbus-comp-product-discobar__segment';
      for(var k=0;k<tiers.length;k++){
        if(tiers[k].qty===i){ seg.textContent=tiers[k].label; break; }
      }
      bar.appendChild(seg);
      boxes.push(seg);
    }

    function unitLabel(n){
      if(!nameSingular && !namePlural) return 'Aerosol'+(n===1?'':'e');
      return n===1 ? (nameSingular||namePlural) : (namePlural||nameSingular);
    }

    var form=getProductForm(root);
    var qtyInput=null;
    var inCartQty=0;
    var lastRaw=null;

    // ✅ CRITICAL: inject properties for cart enforcement
    ensureLineItemProperties(form, snapActive, snapThreshold, snapStep);

    function adjustQty(raw){
      var s=clampMin1(toInt(raw));
      if(!snapActive) return s;

      var dir=null;
      if(lastRaw!=null) dir = s>lastRaw ? 'up' : (s<lastRaw ? 'down' : null);

      var total=inCartQty+s;

      // free zone until threshold-1
      if(total < snapThreshold) return s;

      return (dir==='down')
        ? clampMin1(Math.max(snapThreshold, floorToMultiple(total, snapStep)) - inCartQty)
        : clampMin1(ceilToMultiple(total, snapStep) - inCartQty);
    }

    function render(){
      if(!qtyInput) return;

      var raw=toInt(qtyInput.value);
      var adj=adjustQty(raw);
      if(adj!==raw) qtyInput.value=String(adj);
      lastRaw=raw;

      var eff=inCartQty+adj;

      boxes.forEach(function(b,idx){
        b.classList.toggle('inbus-comp-product-discobar__segment--active', idx < eff);
      });

      info.textContent = inCartQty
        ? ('Menge ausgewählt: '+adj+' • Im Warenkorb: '+inCartQty)
        : ('Menge ausgewählt: '+adj);

      var next=null;
      for(var t=0;t<tiers.length;t++){
        if(eff < tiers[t].qty){ next=tiers[t]; break; }
      }
      if(next){
        var remain = next.qty - eff;
        hint.textContent = 'Noch '+remain+' '+unitLabel(remain)+' für '+nbspPct(next.label)+' Nachlass.';
      } else if(tiers.length){
        hint.textContent = 'Der maximale Preisnachlass von '+nbspPct(tiers[tiers.length-1].label)+' ist erreicht.';
      } else {
        hint.textContent = '';
      }
    }

    function bindQty(){
      // refresh form in case theme re-rendered
      form = getProductForm(root);

      // keep properties present even if form re-rendered
      ensureLineItemProperties(form, snapActive, snapThreshold, snapStep);

      var found=findQtyInput(form);
      if(found && found!==qtyInput){
        qtyInput=found;
        ['input','change','blur','wheel'].forEach(function(ev){
          qtyInput.addEventListener(ev, render);
        });
      }
    }

    bindQty();

    var vid=getCurrentVariantId(form) || toInt(root.getAttribute('data-inbus-variant-id'));
    fetchCart().then(function(){
      inCartQty=computeInCartQty(vid);
      render();
    });

    setInterval(function(){ bindQty(); render(); }, 300);
    setInterval(function(){
      fetchCart().then(function(){
        inCartQty=computeInCartQty(vid);
        render();
      });
    }, 5000);

    new MutationObserver(function(){
      bindQty();
    }).observe(document.body,{childList:true,subtree:true});
  }

  onReady(function(){
    document
      .querySelectorAll('.inbus-comp-product-discobar[data-inbus-discobar="1"]')
      .forEach(initOne);

    new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        if(muts[i].addedNodes && muts[i].addedNodes.length){
          document
            .querySelectorAll('.inbus-comp-product-discobar[data-inbus-discobar="1"]')
            .forEach(initOne);
          break;
        }
      }
    }).observe(document.body,{childList:true,subtree:true});
  });
})();